import React from 'react';


class PaddingPicker extends React.Component {
    constructor(props) {
        super(props);

        
        this.defaultState = this.defaultState.bind(this);
        this.onChange = this.onChange.bind(this);
        this.output = this.output.bind(this);

        this.defaultState(props);

        
    }

    defaultState(props) {
        this.state = {
            top:0,
            right:0,
            bottom:0,
            left:0,
            timestamp:new Date().getMilliseconds()       
        };

        if(props.data != '') {
        	let val = props.data.replace(/px/g, "");
        	let data = props.data.replace(/px/g, "").split(' ');
        	this.state = {
	            top:data[0],
	            right:data[1],
	            bottom:data[2],
	            left:data[3],
	            timestamp:new Date().getMilliseconds()       
	        };

        }
    }

    fixEmpty(val) {
        return val;
    }

    output() {
        let change = this.fixEmpty(this.state.top)+'px '+this.fixEmpty(this.state.right)+'px '+this.fixEmpty(this.state.bottom)+'px '+this.fixEmpty(this.state.left)+'px';
        console.log(change);
        this.props.handlePaddingChange(this.props.id,change);
    }

    componentWillReceiveProps(nextProps) {
        this.defaultState(nextProps);
    }

    componentDidUpdate(prevObject, prevState) {
       if(this.state.timestamp != prevState.timestamp) {
            this.output();
       }
    }

    onChange(e) {
    	let val = e.target.value.replace(/[^0-9.]+/g, "");

    	this.setState({ [e.target.id]:val,timestamp:new Date().getMilliseconds()});
    }

    render() {
        return (
            <div className="col-sm-12 p-0">
                <div className="col-sm-6 p-0">
                    <div className="input-group">
                        <input type="text" className="form-control" id="top" value={this.state.top} onChange={this.onChange} placeholder="Top" />
                        <span className="input-group-addon">px</span>
                    </div>
                </div>

                <div className="col-sm-6 p-2">
                    <div className="input-group">
                        <input type="text" className="form-control" id="right" value={this.state.right} onChange={this.onChange} placeholder="Right" />
                        <span className="input-group-addon">px</span>
                    </div>
                </div>

                <div className="col-sm-6 p-0">
                    <div className="input-group">
                        <input type="text" className="form-control" id="bottom" value={this.state.bottom} onChange={this.onChange} placeholder="Bottom" />
                        <span className="input-group-addon">px</span>
                    </div>
                </div>

                <div className="col-sm-6 p-2">
                    <div className="input-group">
                        <input type="text" className="form-control" id="left" value={this.state.left} onChange={this.onChange} placeholder="Left" />
                        <span className="input-group-addon">px</span>
                    </div>
                </div>
            </div>
        );
    }

  
}

export default PaddingPicker;




// WEBPACK FOOTER //
// ./components/builder/PaddingPicker.js